import React, { useCallback, useEffect, useState } from 'react';

import { Tabs, TabsContent } from '@/components/ui/tabs';
import { WorkspaceLayout } from '../../shared/components/Layout';
import { useSearchBar } from '../../shared/hooks';
import Header from './components/Header';
import { TABS_CONFIG } from './constants';
import { ClientFilterProvider, DecedentFilterProvider } from './context';

const People = () => {
  const [activeTab, setActiveTab] = useState(TABS_CONFIG[0].value);
  const [showDialog, setShowDialog] = useState(false);

  const { handleSearchChange, resetSearch, searchInput, searchQuery } = useSearchBar();

  const handleCloseDialog = useCallback(() => {
    setShowDialog(false);
  }, []);

  const handleOpenDialog = useCallback(() => {
    setShowDialog(true);
  }, []);

  useEffect(() => {
    resetSearch();
  }, [activeTab, resetSearch]);

  return (
    <WorkspaceLayout>
      <ClientFilterProvider>
        <DecedentFilterProvider>
          <Tabs className="h-full" onValueChange={setActiveTab} value={activeTab}>
            <Header
              activeTab={activeTab}
              onNewClick={handleOpenDialog}
              onSearchChange={handleSearchChange}
              searchInput={searchInput}
            />

            {TABS_CONFIG.map(({ component: Component, value }) => (
              <TabsContent key={value} value={value}>
                <Component
                  onCloseDialog={handleCloseDialog}
                  searchQuery={searchQuery}
                  showDialog={showDialog}
                />
              </TabsContent>
            ))}
          </Tabs>
        </DecedentFilterProvider>
      </ClientFilterProvider>
    </WorkspaceLayout>
  );
};

export default People;
